import {
  logo,
  facebook,
  instagram,
  x,
  whatsapp,
  youtube,
  snapchat,
  erroricon,
  googlePlayIcon,
  appStoreIcon,
  tiktok,
} from "assets/icons/index";
import { Link } from "react-router-dom";
import {
  BOARD_OF_DIRECTORS_PATH,
  CONTACT_US_PATH,
  DONATIONS_WAYS_PATH,
  HELP_REQUEST_PATH,
  HUMANITARIAN_CASES_PATH,
  INTERNAL_PROJECTS_PATH,
  ORGANIZATIONAL_STRUCTURE_PATH,
  ORPHAN_SPONSORSHIP_PATH,
  OUR_ACHIEVEMENTS_PATH,
  PRIVACY_POLICY_PATH,
  SEASONAL_PROJECTS_PATH,
  TERMS_PATH,
  VISION_AND_MISSION_PATH,
} from "Routes/paths";
import { useNewsLetterFormik } from "Forms/newsLetterFromik";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t, i18n } = useTranslation();
  const formik = useNewsLetterFormik();

  const { newsEmailLoading } = useSelector(
    (state: RootState) => state.newsLetterReducer
  );

  return (
    <section>
      <footer className="mt-[100px] bg-background_color w-full bg-pro_green px-[30px] lg:px-0 md:pt-[10px] flex flex-col items-center gap-[30px] md:gap-0 md:items-start text-pro_text_dark">
        <div className="mainContainer w-full h-full">
          {/* logo section */}
          <div className="my-[20px] w-[150px]">
            <img src={logo} alt="logo" />
          </div>

          <div className="w-full flex flex-col items-center justify-center md:justify-between md:flex-row md:items-start gap-[20px] pb-[20px] md:px-0">
            {/* Subscribe Newsletter section *************************/}
            <div className="flex items-center">
              <div className="flex flex-col gap-6 justify-center md:justify-start  md:text-left">
                <p
                  className={`${
                    i18n.language === "en"
                      ? "font-Poppins lg:text-left"
                      : "font-Almarai lg:text-right"
                  } font-[600]  text-[16px] text-second_color text-center  `}
                >
                  {t("Subscribe Newsletter")}
                </p>

                {/* Subscribe Newsletter from   *************************/}
                <form onSubmit={formik.handleSubmit}>
                  <Spin spinning={newsEmailLoading}>
                    <label className="relative">
                      <input
                        className="w-full h-[40px] pl-[10px] bg-transparent border-[2px] rounded-[10px] text-[13px] focus:outline-first_color"
                        name="email"
                        type="email"
                        placeholder={t("Type Your Email...")}
                        onChange={formik.handleChange}
                      />

                      <button
                        type="submit"
                        className={`absolute ${
                          i18n.language === "en"
                            ? "font-Poppins top-[7%] right-[5%]"
                            : "font-Almarai top-[7%] left-[5%]"
                        } font-[600] text-[15px] text-first_color`}
                      >
                        {t("Subscribe")}
                      </button>
                    </label>
                  </Spin>

                  {formik.errors.email ? (
                    <p
                      className={`mt-[5px] font-${
                        i18n.language === "en" ? "Poppins" : "Almarai"
                      } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                    >
                      <img className="max-w-[18px]" src={erroricon} alt="" />
                      {formik.errors.email}
                    </p>
                  ) : (
                    ""
                  )}
                </form>

                <Link
                  to={`${TERMS_PATH}`}
                  className={`w-[270px] ${
                    i18n.language === "en"
                      ? "font-Poppins md:text-left"
                      : "font-Almarai md:text-right"
                  } font-[400] text-[12px] text-center underline hover:text-first_color cursor-pointer duration-300`}
                >
                  {t(
                    "By subscribing to our news letter, you agree to our terms & conditions."
                  )}
                </Link>
              </div>
            </div>

            {/* What We Do section *******************************/}
            <div className="flex items-center">
              <div
                className={
                  i18n.language === "en"
                    ? "text-center md:text-left flex flex-col"
                    : "text-center md:text-right flex flex-col"
                }
              >
                <p className="font-[700] font-Avenir_demi text-[16px]">
                  {t("What We Do")}
                </p>

                <Link
                  to={INTERNAL_PROJECTS_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Internal Projects")}
                </Link>
                <Link
                  to={SEASONAL_PROJECTS_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Seasonal Projects")}
                </Link>
                <Link
                  to={HUMANITARIAN_CASES_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Humanitarian Cases")}
                </Link>
                <Link
                  to={ORPHAN_SPONSORSHIP_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Orphans Sponsorship")}
                </Link>
              </div>
            </div>

            {/* Media Center section *******************************/}
            {/* <div className="flex items-center">
              <div
                className={
                  i18n.language === "en"
                    ? "text-center md:text-left flex flex-col"
                    : "text-center md:text-right flex flex-col"
                }
              >
                <p className="font-[700] font-Avenir_demi text-[16px] whitespace-nowrap">
                  {t("Media Center")}
                </p>

                <Link
                  to={NEWS_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("News")}
                </Link>
                <Link
                  to={VIDEOS_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Videos")}
                </Link>
              </div>
            </div> */}

            {/* Who We Are section *******************************/}
            <div className="flex items-center">
              <div
                className={
                  i18n.language === "en"
                    ? "text-center md:text-left flex flex-col"
                    : "text-center md:text-right flex flex-col"
                }
              >
                <p className="font-[700] font-Avenir_demi text-[16px]">
                  {t("Who We Are")}
                </p>

                <Link
                  to={VISION_AND_MISSION_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Vision And Mission")}
                </Link>
                <Link
                  to={BOARD_OF_DIRECTORS_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Board of Directors")}
                </Link>
                <Link
                  to={OUR_ACHIEVEMENTS_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Our Achievements")}
                </Link>
                <Link
                  to={DONATIONS_WAYS_PATH}
                  className="hover:text-first_color duration-300"
                >
                  {t("Donation Ways")}
                </Link>
              </div>
            </div>

            {/* download the app section  ************************/}
            <div className="flex items-center">
              <div
                className={
                  i18n.language === "en"
                    ? "text-center md:text-left flex flex-col gap-3"
                    : "text-center md:text-right flex flex-col gap-3"
                }
              >
                {/* <p className="font-[400]  whitespace-nowrap">
                  {t("No. of Visitors")}{" "}
                  <span className="ml-[10px] font-[700] font-Avenir_demi text-[16px] text-black">
                    1248578
                  </span>
                </p> */}

                <div className="flex flex-col gap-2">
                  <p className="font-[700] font-Avenir_demi text-[16px] text-black">
                    {t("Download Our Application Now")}
                  </p>
                  <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
                    <img
                      onClick={() => {
                        window.open(
                          "https://play.google.com/store/apps/details?id=com.manar.charity&hl=en&pli=1"
                        );
                      }}
                      className="cursor-pointer hover:shadow-xl duration-150 w-[140px] h-[55px] bg-black p-[9px] rounded-lg"
                      src={googlePlayIcon}
                      alt=""
                    />
                    <img
                      onClick={() => {
                        window.open(
                          "https://apps.apple.com/ae/app/al-etihad-charity/id1616874965"
                        );
                      }}
                      className="cursor-pointer hover:shadow-xl duration-150 w-[140px] h-[55px] bg-black p-[9px] rounded-lg"
                      src={appStoreIcon}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* copy right and social section *****************************/}
      <div className="bg-[#ECE1D4] px-[30px] lg:px-0 py-[20px] w-full ">
        <div className="mainContainer w-full h-full flex flex-col lg:flex-row items-center justify-between gap-4">
          <p
            className={`font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[400] text-[14px]`}
          >
            {" "}
            {t("Copyright@ Aletihad Charity Foundation")}
          </p>

          <div className="flex flex-col xl:flex-row items-center gap-6 lg:gap-8">
            <div className="flex flex-col lg:flex-row items-center gap-4">
              <a
                href="http://manar.ddns.net:5252/ManarSchool/UserHome/HelpingGateLogin"
                target="_blank"
                rel="noreferrer"
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[400]  text-[15px] hover:text-first_color duration-300`}
              >
                {t("Student Registration for School")}
              </a>
              <Link
                to={HELP_REQUEST_PATH}
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[400]  text-[15px] hover:text-first_color duration-300`}
              >
                {t("Helping Cases")}
              </Link>
              <Link
                to={`${PRIVACY_POLICY_PATH}`}
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[400]  text-[15px] hover:text-first_color duration-300`}
              >
                {t("Privacy Policy")}
              </Link>
              <Link
                to={`${CONTACT_US_PATH}`}
                className={`font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[400] text-[15px] hover:text-first_color duration-300`}
              >
                {t("Contact Us")}
              </Link>
            </div>

            {/* socail links  */}
            <div className="flex items-center gap-8">
              {" "}
              {/* facebook */}
              <a href="https://m.facebook.com/etihadcharity" target="_blank">
                <img
                  className="hover:scale-150 duration-300"
                  src={facebook}
                  alt=""
                />
              </a>
              {/* instagram */}
              <a
                href="https://instagram.com/etihadcharity?igshid=YmMyMTA2M2Y="
                target="_blank"
              >
                <img
                  className="hover:scale-150 duration-300"
                  src={instagram}
                  alt=""
                />
              </a>
              {/* x */}
              <a
                href="https://twitter.com/etihadcharity?s=20&t=qrWYlqbLqUzvt6gx1W0P8g"
                target="_blank"
              >
                {" "}
                <img className="hover:scale-150 duration-300" src={x} alt="" />
              </a>
              {/* whatsapp */}
              <a
                href="https://api.whatsapp.com/send?phone=97180062&text=Hi"
                target="_blank"
              >
                {" "}
                <img
                  className="hover:scale-150 duration-300"
                  src={whatsapp}
                  alt=""
                />
              </a>
              {/* youtube */}
              <a
                href="https://www.youtube.com/channel/UCpXCNb-HmlKfNHfSiE4CIeA"
                target="_blank"
              >
                <img
                  className="hover:scale-150 duration-300"
                  src={youtube}
                  alt=""
                />
              </a>
              {/* snapchat */}
              <a href="https://www.snapchat.com/add/miecajman" target="_blank">
                {" "}
                <img
                  className="hover:scale-150 duration-300"
                  src={snapchat}
                  alt=""
                />
              </a>
              {/* tiktok */}
              <a
                href="https://www.tiktok.com/@etihad_charity?_t=ZS-8uyUVUF8EHC&_r=1"
                target="_blank"
              >
                {" "}
                <img
                  className="w-[22px] hover:scale-150 duration-300"
                  src={tiktok}
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
